// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Manipulation } from 'swiper/modules';


let gallery = document.querySelectorAll('.product-gallery');
if (gallery.length) {
	for (let i = 0; i < gallery.length; i++) {

		let thumbnails = gallery[i].querySelectorAll('.product-gallery-thumblist-item:not(.video-item)'),
			videos = gallery[i].querySelectorAll('.product-gallery-thumblist-item.video-item');


		for (let n = 0; n < thumbnails.length; n++) {
			thumbnails[n].addEventListener('click', (e) => {
				e.preventDefault();
				changePreview(thumbnails[n]);
			});
		}

		// Changer preview function


		// Video thumbnail - open video in lightbox
		for (let m = 0; m < videos.length; m++) {
			lightGallery(videos[m], {
				selector: 'this',
				download: false,
				videojs: true,
				youtubePlayerParams: {
					modestbranding: 1,
					showinfo: 0,
					rel: 0,
					controls: 0
				},
				vimeoPlayerParams: {
					byline: 0,
					portrait: 0,
					color: 'fe696a'
				}
			});
		}
	}
}


function changePreview(el) {

	let gallery = document.querySelector('.product-gallery');

	// Refresh thumbnails and previews because Slider can make new thumnbs
	let thumbnails = gallery.querySelectorAll('.product-gallery-thumblist-item:not(.video-item)')
	let previews = gallery.querySelectorAll('.product-gallery-preview-item');
	thumbnails.forEach((item) => {
		item.classList.remove('active');
	});
	previews.forEach((item) => {

		item.classList.remove('active');
	});


	el.classList.add('active');
	gallery.querySelector(el.getAttribute('href')).classList.add('active');
}




if (document.querySelector('.swiper')) {
	const swiper = new Swiper('.swiper', {
		// Optional parameters
		direction: 'horizontal',
		loop: false,
		slidesPerView: 6.5,
		spaceBetween: 10,
		slideActiveClass: 'active',
		autoHeight: false,
		freeMode: false,
		centeredSlides: true,
		modules: [Navigation, Manipulation],

		breakpoints: {
			// when window width is >= 320px
			320: {
				slidesPerView: 3.5,
				spaceBetween: 5
			},
			// when window width is >= 480px
			480: {
				slidesPerView: 3.5,
				spaceBetween: 10
			},
			// when window width is >= 640px
			640: {
				slidesPerView: 4.5,
				spaceBetween: 10
			},
			// when window width is >= 920px
			920: {
				slidesPerView: 6.5,
				spaceBetween: 10,
				centeredSlides: false,
			}
		},


		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		scrollbar: {
			el: '.swiper-scrollbar',
		},
	});


	swiper.on('slideChange', (swiper) => {
		changePreview(swiper.slides[swiper.activeIndex]);
	});


	window.productThumbSwiper = swiper;
}

